module.exports = __webpack_public_path__ + "9788f41e/img/arrow-left-icon.785c715c.svg";